export enum StoragesProvidersEnum {
    LOCAL_STORAGE = "localStorage",
}
